  export const validateIban = (iban: string): boolean => {
    if (!iban || iban === '' || iban === 'TR') {
      return true; // Allow empty for optional validation
    }

    let bankAccount = iban.replace(/\s/g, '').toUpperCase();

    if (!/^[A-Z0-9]+$/.test(bankAccount)) {
      return false;
    }

    bankAccount = bankAccount.substr(4) + bankAccount.substr(0, 4);
    let asciiShift = 55;
    let sb = '';

    for (let i = 0; i < bankAccount.length; i++) {
      let c = bankAccount.charAt(i);
      let v;
      if (/[A-Z]/.test(c)) {
        v = c.charCodeAt(0) - asciiShift;
      } else {
        v = parseInt(c);
      }
      sb += v;
    }

    let checkSumString = sb;
    let checksum = parseInt(checkSumString.substr(0, 1));

    for (let i = 1; i < checkSumString.length; i++) {
      let v = parseInt(checkSumString.substr(i, 1));
      checksum *= 10;
      checksum += v;
      checksum %= 97;
    }

    return checksum === 1;
  };

  // Phone number validation for Turkish mobile numbers
  export const validatePhoneNumber = (phone: string): boolean => {
    if (!phone || phone === '') {
      return false;
    }

    // Remove all whitespace and formatting characters
    const cleanPhone = phone.toString().replace(/[\s\-\(\)]/g, '');
    
    // Turkish mobile phone patterns
    const patterns = [
      /^905[0-9]{9}$/, // 905xxxxxxxxx format
    ];

    return patterns.some(pattern => pattern.test(cleanPhone));
  };

  // TCKN validation
 export  const validateTCKN = (tckn: string): boolean => {
    if (!tckn || tckn === '') {
      return false; // TCKN is now required
    }

    const tcknStr = tckn.toString();
    const arr = tcknStr.split('').map(Number);
    let sumEven = 0;
    let sumOdd = 0;
    let sumFirst10 = 0;
    let i = 0;

    if (tcknStr.length !== 11) {
      return false;
    }

    if (arr[0] === 0) {
      return false;
    }

    while (i <= 8) {
      const temp = arr[i];
      sumFirst10 += temp;
      if (i % 2 === 1) {
        sumEven += temp;
      } else {
        sumOdd += temp;
      }
      i++;
    }
    sumFirst10 += arr[9];

    if (
      !(
        (sumEven * 9 + sumOdd * 7) % 10 === arr[9] &&
        sumFirst10 % 10 === arr[10]
      )
    ) {
      return false;
    }

    return true;
  };